import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const PricingBarWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 320px;
  flex-shrink: 0;
  width: calc(100% - 32px);
  margin: 0 auto 0px auto;
  @media ${device.mobileM} {
    width: calc(100% - 56px);
    margin: 0 auto 0px auto;
  }
  @media ${device.tablet} {
    width: calc(100% - 120px);
    margin: 0 auto 96px auto;
  }
  @media ${device.laptopL} {
    width: calc(100% - 192px);
    margin: 0 auto 96px auto;
  }
  @media ${device.desktop} {
    width: 100%;
    max-width: 1248px;
    margin: 0 auto 96px auto;
  }
`;

export const BackgroundColorWrap = styled.div`
  background-color: ${COLORS.white};
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Audi Type';
  font-size: 16px;
  padding-top: 24px;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  @media ${device.laptop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 320px;
    flex-shrink: 0;
  }
`;

export const CTAWrapper = styled.div`
  width: 100%;

  @media ${device.laptop} {
    width: unset;
  }
`;
